<template>
  <div class="animated fadeIn">
    <div class="w-100 px-3 kanban-nav">
      <h5 class="pt-md-2 pt-3">
          <span class="d-md-down-none">
            <i class="fas fa-headset"></i> Atendimento
          </span>
        </h5>
    </div>
    <div class="kanban-container">
      <div class="kanban-board">
        <div class="col-md-3" style="border: solid 1px #ccc; max-width: 100%; min-height: 600px;margin-bottom: 2px; background-color: #fff; border-radius: 5px;">
          <div class=" col-12 pt-3 pb-2" style="border-bottom: solid 1px #dcdcdc;">
            <h5><i class="fas fa-comments text-third"></i> Suas conversas</h5>
          </div>
          <ListaContato ref="ListaContato" />
        </div>
        <div class="col-md-6" style="border: solid 1px #ccc; max-width: 100%; min-height: 600px;margin-left: 1px; margin-right: 1px;margin-bottom: 2px; background-color: #fff; border-radius: 5px;">
          <div class=" col-12 pt-3 pb-2" style="border-bottom: solid 1px #dcdcdc;">
            <h5><i class="fas fa-user text-third"></i> João Paulo</h5>
            <span style="display: block; position: absolute; right: 5px; top: 10px;"><i class="fas fa-ellipsis-h"></i></span>
          </div>
          <Chat ref="Chat" />
        </div>
        <div class="col-md-3" style="border: solid 1px #ccc; max-width: 100%; min-height: 600px;margin-bottom: 2px; background-color: #fff; border-radius: 5px;">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ListaContato from './components/listacontato.vue'
import Chat from './components/chat.vue'
export default {
  name: 'Atendimento',
  components: {
    ListaContato,
    Chat
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/atendimento.vue